import HierarchyWidget from 'girder/views/widgets/HierarchyWidget';
import View from 'girder/views/View';
import { AccessType } from 'girder/constants';
import { restRequest } from 'girder/rest';
import { getCurrentUser } from 'girder/auth';

import AnalysisOptionsWidget from './AnalysisOptionsWidget';
import AnalysesActionsMenuTemplate from '../../templates/widgets/analysesActionsMenu.pug';

import { parse } from 'girder_plugins/slicer_cli_web/parser';
import 'girder/utilities/jquery/girderEnable';

import _ from 'underscore';


/**
 * This widget presents a list of available analyses batch processing actions
 * on a set of selected resources.
 */
var AnalysesMenuWidget = View.extend({
    events: {
        'click .g-analyses-option': function(e) {
            var analysisData = $(e.currentTarget).data() || {};
            var analysisExtraOpts = [];
            this._analysisName = e.currentTarget.innerText || '';

            var opts = {
                el: $('#g-dialog-container'),
                model: this.parentModel,
                analysisName: this._analysisName,
                parentView: this
            };

            this._analysisData = {
                'cli': analysisData.cli,
                'api': analysisData.api,
            };
            this._analysisJob = {};

            var privateFolderRequest;
            var xmlRequest = restRequest({
                url: analysisData.api + '/xmlspec',
                dataType: 'xml'
            }).then(_.bind(function (xml) {
                var xmlJsonOpts = {}
                var xmlJson = parse(xml, xmlJsonOpts);
                if (_.isString(xmlJson)) {
                    xmlJson = JSON.parse(xmlJson);
                }
                xmlJson['panels'].forEach((panel) => {
                    panel['groups'].forEach((group) => {
                        group['parameters'].forEach((params) => {
                            let params_id = String(params.id) || '';
                            let params_value = String(params.value) || '';
                            let params_type = params.type;
                            if (params_type != 'image' &&
                                params_type != 'new-file' &&
                                params_type != 'region') {
                                analysisExtraOpts.push(params);
                            } else if (params_type == 'new-file') {
                                let userId = getCurrentUser().get('_id');
                                privateFolderRequest = restRequest({
                                    url: `/folder?parentType=user&parentId=${userId}`,
                                }).then((folders) => {
                                    let privateFolderId = folders.filter( folder => folder.name == "Private")[0]._id;
                                    this._analysisJob[params_id + '_girderFolderId'] = privateFolderId;
                                    this._analysisJob[params_id + '_name'] = analysisData.cli + "-" + params_id + params.extensions;
                                });
                            } else if (params_type == 'region'){
                                this._analysisJob[params_id] = JSON.stringify(params_value.split(',').map(r => parseInt(r, 10)));
                            } else if (params_type == 'image') {
                                this._imageKey = params_id + '_girderFileId';
                                this._analysisJob[this._imageKey] = '';
                            } else if (params_value) {
                                this._analysisJob[params_id] = params_value;
                            }
                        });
                    });
                });

                $.when(
                    privateFolderRequest,
                ).done(() => {
                    opts['analysisExtraOpts'] = analysisExtraOpts || [];

                    if (!this.analysisOptionsWidget) {
                        this.analysisOptionsWidget = new AnalysisOptionsWidget(opts);
                        this.analysisOptionsWidget.render();
                    } else {
                        this.analysisOptionsWidget.update(opts);
                    }
                    if (!opts['analysisExtraOpts'].length) {
                        this.startAnalysis({});
                    };
                });
            }, this));
        }
    },

    initialize: function (params) {
        this._fetchAndInit(params);
        this._noAnalyses = false;
        this.analysesOptions = [];
        this.dropdownToggle = params.dropdownToggle;
    },

    render: function () {
        // If nothing is checked, disable the parent element and return
        if (this.folderCount + this.itemCount + this.pickedCount === 0) {
            this.dropdownToggle.girderEnable(false);
            return;
        }

        if (!Object.entries(this.analysesOptions).length && !this._noAnalyses) {
            var analysesOptionsPromise = restRequest({
                url: '/HistomicsTK/HistomicsTK/docker_image'
            }).done((resp) => {
                this.analysesOptions = resp;
            }).fail((error) => {
                this._noAnalyses = true;
            });

            $.when(
                analysesOptionsPromise,
            ).done(() => {
                // enable Analyses menu
                this._updateMenu();
            }).fail(() => {
                // disable Analyses menu
                this._updateMenu();
            });
        } else {
            this._updateMenu();
        }

        return this;
    },

    /**
     * This should be called when the checkbox selection changes. It will
     * update and re-render the checked action menu.
     * @param minLevel The minimum access level across the checked resource set.
     * @param folderCount The number of checked folders.
     * @param itemCount The number of checked items.
     */
    update: function (params) {
        if (params) {
            this._fetchAndInit(params);
        }
        this.render();
    },

    startAnalysis: function (args) {
        var widget = this;
        var items = this.resources["item"] || [];
        var folders = this.resources["folder"] || [];

        var analysisJob = this._analysisJob;
        _.each(args, function (value, key) {
            analysisJob[key] = JSON.stringify(value);
        });

        var itemListView = this.parentView.itemListView;

        folders.forEach((folderId) => {
            var folderItems = [];
            var folderItemsRequest = restRequest({
                url: '/item',
                method: 'GET',
                data: { 'folderId': folderId },
            }).done((resp) => {
                folderItems = resp;
            });
            $.when(folderItemsRequest).done((folderItems) => {
                folderItems.forEach((folderItem) => {
                    restRequest({
                        url: '/item/' + folderItem
                    }).then((folderItemData) => {
                        return this._runJob(folderItem, folderItemData, analysisJob);
                    });
                });
            });
        });

        items.forEach((item) => {
            restRequest({
                url: '/item/' + item
            }).then((itemData) => {
                return this._runJob(item, itemData, analysisJob);
            });
        });
        itemListView.render();
    },

    _runJob: function (itemId, itemData, analysisJob) {
        var analysisRun = {
            'moduleData': this._analysisData,
            'moduleJob': analysisJob,
        };
        var imageKey = this._imageKey;
        if (itemData.largeImage && itemData.largeImage.fileId) {
            analysisRun['item'] = itemData.largeImage.fileId;
            analysisRun['moduleJob'][imageKey] = analysisRun['item'];
            restRequest({
                url: analysisRun.moduleData.api + '/run',
                method: 'POST',
                data: analysisRun.moduleJob
            }).then((response) => {
                var jobIds = {};
                if (!('meta' in itemData) || !('jobIds' in itemData.meta)) {
                    jobIds = {"jobIds": response._id};
                } else {
                    jobIds = {"jobIds": itemData.meta.jobIds + ',' + response._id};
                }
                console.log(jobIds);
                restRequest({
                    url: '/item/' + itemId + '/metadata',
                    method: 'PUT',
                    contentType: 'application/json',
                    data: JSON.stringify(jobIds)
                });
            });
        }
        return null;
    },

    _fetchAndInit: function (params) {
        this.minFolderLevel = params.minFolderLevel || AccessType.READ;
        this.minItemLevel = params.minItemLevel || AccessType.READ;
        this.folderCount = params.folderCount || 0;
        this.itemCount = params.itemCount || 0;
        this.resources = params.resources || [];

        this._analysisName = '';
        this._imageKey = '';
        this._analysisData = {};
        this._analysisJob = {};
    },

    _updateMenu: function() {
        if (Object.entries(this.analysesOptions).length) {
            this.dropdownToggle.girderEnable(true);
            this.$el.html(AnalysesActionsMenuTemplate({
                minFolderLevel: this.minFolderLevel,
                minItemLevel: this.minItemLevel,
                folderCount: this.folderCount,
                itemCount: this.itemCount,
                analysesOptions: this.analysesOptions,
                AccessType: AccessType,
                HierarchyWidget: HierarchyWidget
            }));
        } else {
            this.dropdownToggle.girderEnable(false);
            this.parentView.$('.g-analyses-actions-button').prop('title', 'No analyses modules installed');
        }
    },
});

export default AnalysesMenuWidget;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/widgets/AnalysesMenuWidget.js